"use client";

import React from 'react';
import { motion, useInView } from 'framer-motion';

export type SlideFadeInProps = {
  children?: React.ReactNode;
  className?: string;
  animation?: {
    startXPos?: number
    startYPos?: number;
    endXPos?: number;
    endYPos?: number;
    duration?: number;
    delay?: number;
    animateInView?: boolean;
    viewMargin?: any;
  }
}

function Slide(props: SlideFadeInProps) {
  const ref = React.useRef(null);
  const isInView = useInView(ref, {once: true, margin: props.animation?.viewMargin || "0px"});
  const checkView = props.animation?.animateInView !== undefined ? props.animation?.animateInView : true;

  const variants = {
    hidden: {
      x: props.animation?.startXPos || 0,
      y: props.animation?.startYPos || 0,
      ease: [.25, .1, .25, 1] as [number, number, number, number],
    },
    visible: {
      x: props.animation?.endXPos || 0,
      y: props.animation?.endYPos || 0,
      transition: {
        delay: props.animation?.delay || 0,
        duration: props.animation?.duration || 0.5,
        ease: [.25, .1, .25, 1] as [number, number, number, number],
      },
    },
  }


  return (
    <motion.div
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={checkView ? (isInView ? "visible" : "hidden") : "visible"}
      className={props.className || ""}
    >
      {props.children}
    </motion.div>
  );
}

export default Slide;